import React, { useState, useEffect } from 'react';
import './Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalProducts: 0,
    totalOrders: 0,
    pendingOrders: 0,
    totalRevenue: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('token');
      
      // Fetch product groups count
      const productsRes = await fetch(`${API_URL}/product-groups/admin/all?limit=1`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const productsData = await productsRes.json();
      
      // Fetch order stats
      const ordersRes = await fetch(`${API_URL}/orders/stats`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const ordersData = await ordersRes.json();
      
      setStats({
        totalProducts: productsData.total || productsData.count || 0,
        totalOrders: ordersData.data?.total_orders || 0,
        pendingOrders: ordersData.data?.pending_orders || 0,
        totalRevenue: parseFloat(ordersData.data?.total_revenue || 0)
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const statCards = [
    { label: 'Total Products', value: stats.totalProducts, color: '#C9A882' },
    { label: 'Total Orders', value: stats.totalOrders, color: '#4CAF50' },
    { label: 'Pending Orders', value: stats.pendingOrders, color: '#FF9800' },
    { label: 'Total Revenue', value: `$${stats.totalRevenue.toFixed(2)}`, color: '#2196F3' }
  ];

  if (loading) {
    return <div className="dashboard-loading">Loading dashboard...</div>;
  }

  return (
    <div className="dashboard">
      <div className="stats-grid">
        {statCards.map((stat, index) => (
          <div key={index} className="stat-card" style={{ borderTopColor: stat.color }}>
            <div className="stat-content">
              <div className="stat-label">{stat.label}</div>
              <div className="stat-value">{stat.value}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h3>Quick Actions</h3>
          <div className="quick-actions">
            <button className="action-btn" onClick={() => window.location.href = '/management/products'}>
              <span>Add Product</span>
            </button>
            <button className="action-btn" onClick={() => window.location.href = '/management/orders'}>
              <span>View Orders</span>
            </button>
            <button className="action-btn" onClick={() => window.open('/', '_blank')}>
              <span>View Website</span>
            </button>
          </div>
        </div>

        <div className="dashboard-card">
          <h3>Recent Activity</h3>
          <div className="activity-list">
            <div className="activity-item">
              <div className="activity-content">
                <div className="activity-text">System initialized</div>
                <div className="activity-time">Just now</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
